(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-content-pdp"] && !window.DesignMode) return;
  try {
    
// No JS needed unless you want animations or lazy loading

  } catch(e) { console.error(e); }
})();
})();
